module.exports = __webpack_public_path__ + "static/dv360-full-e59b9c11d43336f9fea6977582d54acd.svg";